import React from "react";
import Card from "../../newComponents/card";

const Download = ({ block }) => (
  <section>
    <div className="shell">
      <div className="boxes swiper-container js-load-more js-slider-boxes-projects mb-4">
        <ul>
          {block.file.map((item, i) => (
            <Card key={item.url} image={block.customFeatureImage.length >= block.file.length ? block.customFeatureImage[i] : block.customFeatureImage[0]} ar={3} title={item.title} readMoreLabel="Download" href={"https://cms.genesis-analytics.com" +  item.url} subtitle={item.summary} color={1}/>
          ))}
        </ul>
        <div className="swiper-pagination boxes__pagination" />
      </div>
    </div>
  </section>
)

export default Download;
